import styled from 'styled-components';

export const SubTitle = styled('p')`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
  margin-bottom: 16px;
`;

export const ForgotPassword = styled.a`
  display: inline-block;

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

  color: #262ba6;
  margin-top: 8px;
  cursor: pointer;
`;
